import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import TextField from "@mui/material/TextField";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import DialogActions from "@mui/material/DialogActions";
import { useNavigate } from "react-router";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Unstable_Grid2";
import TableHeader from "components/Table/TableHeader";
import TableElement from "components/Table/TableElement";
import { useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setLoadingPanel } from "../../redux/features/loading";
import CircularIndeterminateModal from "../../utils/Loading";
import {
  GetPriceDrops,
  addPriceDrop,
  deletePriceDrop,
} from "../../apis/MyDukanPriceDropApi";
import { GetBrands } from "../../apis/MyDukanBrandApi";
import { GetProducts } from "../../apis/MyDukanProductsApi";
import CustomDropdown from "components/CustomDropdown";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const LastDayOfMonth = (y, m) => {
  return new Date(y, m, 0).getDate();
};

export default function MyDukanPriceDrop() {
  const navigate = useNavigate();
  const date = new Date();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.loadingReducer.isLoading);
  const [month, setMonth] = useState(date.getMonth() + 1);
  const months = [
    {
      name: "January",
      value: 1,
    },
    {
      name: "February",
      value: 2,
    },
    {
      name: "March",
      value: 3,
    },
    {
      name: "April",
      value: 4,
    },
    {
      name: "May",
      value: 5,
    },
    {
      name: "June",
      value: 6,
    },
    {
      name: "July",
      value: 7,
    },
    {
      name: "August",
      value: 8,
    },
    {
      name: "September",
      value: 9,
    },
    {
      name: "October",
      value: 10,
    },
    {
      name: "November",
      value: 11,
    },
    {
      name: "December",
      value: 12,
    },
  ];
  const [year, setYear] = useState(date.getFullYear());
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [totalElements, setTotalElements] = useState("");
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [priceDropForm, setPriceDropForm] = useState({
    priceDropId: null,
    brandId: "",
    productId: "",
    userGroupId: "144",
    dropDate: "",
    priceDropClaimValue: "",
    periodMonth: date.getMonth() + 1,
    periodYear: date.getFullYear(),
    periodFrom: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-01`,
    periodTo: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(
      LastDayOfMonth(date.getFullYear(), date.getMonth() + 1)
    ).padStart(2, "0")}`,
  });

  const INI_STATE = {
    priceDropId: null,
    brandId: "",
    productId: "",
    userGroupId: "144", 
    dropDate: "",
    priceDropClaimValue: "",
    periodMonth: date.getMonth() + 1,
    periodYear: date.getFullYear(),
    periodFrom: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-01`,
    periodTo: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(
      LastDayOfMonth(date.getFullYear(), date.getMonth() + 1)
    ).padStart(2, "0")}`,
  };
  const [brands, setBrands] = useState([]);
  const [products, setProducts] = useState([]);

  const [selectedBrandForAdd, setSelectedBrandForAdd] = useState("");
  const [open, setOpen] = React.useState(false);
  const [drops, setDrops] = useState([""]);
  const [isEditingDrop, setIsEditingDrop] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getBrands();
  }, []);

  const getBrands = () => {
    dispatch(setLoadingPanel(true));
    GetBrands({ page: 0, size: 999 })
      .then((res) => {
        const uniqueBrands = [];
        const brandIds = new Set();
        
        (res.data?.brands || [])
          .filter(b => b.active)
          .forEach(brand => {

            if (!brandIds.has(brand.id)) {
              brandIds.add(brand.id);
              uniqueBrands.push(brand);
            }
          });
          
        setBrands(uniqueBrands);
        setSelectedBrand(null);
        getDrops(null, 0);
        dispatch(setLoadingPanel(false));
      })
      .catch((err) => {
        dispatch(setLoadingPanel(false));
        toast(err?.response?.data?.message, {
          type: "error",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            maxWidth: "90vw",
            width: "auto",
            margin: "5px  auto",
            padding: "5px 5px",
            fontSize: "14px",
          },
          closeButton: (
            <div className="flex justify-end">
              <button className="text-gray-500 hover:text-gray-800 focus:outline">
                <CloseIcon className="w-7 h-7" />
              </button>
            </div>
          ),
        });
      });
  };

  useEffect(() => {
    getDrops(
      selectedBrand && selectedBrand.id ? selectedBrand.id : null,
      0
    );
  }, [selectedBrand, priceDropForm.periodFrom, priceDropForm.periodTo]);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
    if (selectedBrand && selectedBrand.id) {
      getDrops(selectedBrand.id, page - 1);
    }
    return currentPage;
  };
  const getDrops = (brandId, startPosition = 0) => {
    GetPriceDrops({
      startPosition,
      maxResult: 25,
      brand: brandId,
      periodFrom: priceDropForm.periodFrom || "",
      periodTo: priceDropForm.periodTo || "",
    })
      .then((res) => {
        setDrops(res.data?.priceDrops || []);
        setTotalElements(res.data?.totalElements || 0);
        setTotalPages(Math.ceil((res.data?.totalElements || 0) / 25));
      })
      .catch((err) => {
        toast(err?.response?.data?.message || "Error fetching price drops", {
          type: "error",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      });
  };

  const handleChange = (event) => {
    setTimeout(() => {
      if (event.target.value === null) {
        setSelectedBrand(null);
      } else {
        setSelectedBrand(event.target.value);
      }
    }, 50);
  };

  const addScheme = () => {
    setOpen(true);
  };

  const save = () => {
    const payload = {
      priceDropId: null,
      brandId: priceDropForm.brandId,
      productId: priceDropForm.productId,
      userGroupId: "144",
      dropDate: priceDropForm.dropDate,
      priceDropClaimValue: priceDropForm.priceDropClaimValue,
    };
    addPriceDrop(payload)
      .then((res) => {
        getDrops(null, 0);
        setOpen(false);
        setPriceDropForm(INI_STATE);
        toast("Price Drop Added", { type: "success" });
      })
      .catch((err) => {
        toast(err?.response?.data?.message || "Error adding price drop", {
          type: "error",
          autoClose: 1000,
        });
      });
  };

  const handleDelete = (priceDropId) => {
    deletePriceDrop(priceDropId)
      .then((res) => {
        getDrops(null, 0);
        toast("Price Drop Deleted", { type: "success" });
      })
      .catch((err) => {
        toast(err?.response?.data?.message || "Error deleting price drop", {
          type: "error",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      });
  };

  const isMobile = useMediaQuery("(max-width:768px)");


  const searchProducts = async (keyword) => {
    if (!priceDropForm.brandId) {
      toast("Please select a brand first", { type: "warning" });
      return [];
    }
    
    try {
      const res = await GetProducts({ 
        brandId: priceDropForm.brandId,
        keyword: keyword || ''
      });
      

      return (res.data?.products || []).filter(p => p.active);
    } catch (error) {
      toast("Error searching products", { type: "error" });
      return [];
    }
  };

  useEffect(() => {
    if (priceDropForm.brandId) {

      setProducts([]);
      
      GetProducts({ brandId: priceDropForm.brandId })
        .then((res) => {
          setProducts(res.data?.products || []);
        })
        .catch(err => {
          toast("Error fetching products", { type: "error" });
          setProducts([]);
        });
    } else {
      setProducts([]);
    }
  }, [priceDropForm.brandId]);

  // No need to fetch groups anymore as we're using fixed All Users group
  // useEffect(() => {
  //   getGroups().then((res) => {
  //     setGroups((res.data?.groups || []).filter((g) => g.isActive));
  //   });
  // }, []);

  return (
    <>
      <CircularIndeterminateModal open={isLoading && !brands.length} />
      <div
        className="page-card mb-6"
      >
        <div className="block w-full overflow-x-auto p-4 md:p-8">
          <Box className="w-full">
            <FormControl fullWidth>
              <CustomDropdown
                options={brands}
                value={selectedBrand?.id || ""}
                onChange={(selectedBrand) => {
                  setSelectedBrand(selectedBrand);
                  getDrops(selectedBrand?.id || null, 0);
                }}
                getOptionLabel={(option) => option.name || ""}
                getOptionValue={(option) => option.id}
                label="Select Brand"
                placeholder="Type to search brands..."
                helpText="Type to get the brands"
                fullWidth
                sx={{ 
                  mb: 2,
                  "& .MuiPaper-root": {
                    zIndex: 9999,
                    maxHeight: "300px"
                  },
                  "& .MuiAutocomplete-listbox": {
                    maxHeight: "250px"
                  }
                }}
                disableCloseOnSelect={false}
                blurOnSelect={false}
                forcePopupIcon={true}
                openOnFocus={true}
                ListboxProps={{
                  style: { maxHeight: '250px' }
                }}
                PopperProps={{
                  style: { zIndex: 9999, width: '100%' }
                }}
              />
            </FormControl>
            <div style={{ marginTop: "15px" }}>
              <Grid container spacing={2}>
                <Grid xs={12}>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, mb: 1 }}
                  >
                    Period
                  </Typography>
                  <Box sx={{ width: "100%" }}>
                    <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
                      <FormControl sx={{ minWidth: 120, flex: 1 }} fullWidth>
                        <InputLabel id="period-month-label">Month</InputLabel>
                        <Select
                          labelId="period-month-label"
                          id="period-month"
                          value={priceDropForm.periodMonth || ""}
                          label="Month"
                          onChange={(e) =>
                            setPriceDropForm({
                              ...priceDropForm,
                              periodMonth: e.target.value,
                            })
                          }
                        >
                          {months.map((m) => (
                            <MenuItem key={m.value} value={m.value}>
                              {m.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <TextField
                        type="number"
                        label="Year"
                        value={priceDropForm.periodYear || ""}
                        onChange={(e) =>
                          setPriceDropForm({
                            ...priceDropForm,
                            periodYear: e.target.value,
                          })
                        }
                        sx={{ minWidth: 120, flex: 1 }}
                        fullWidth
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </div>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                gap: 2,
                justifyContent: "flex-end",
              }}
            >
              <Button variant="contained" color="primary" onClick={addScheme}>
                Add New Price Drop
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  const pad = (n) => n.toString().padStart(2, "0");
                  let periodFrom = "";
                  let periodTo = "";
                  if (priceDropForm.periodYear && priceDropForm.periodMonth) {
                    periodFrom = `${priceDropForm.periodYear}-${pad(
                      priceDropForm.periodMonth
                    )}-01`;
                    const lastDay = LastDayOfMonth(
                      priceDropForm.periodYear,
                      priceDropForm.periodMonth
                    );
                    periodTo = `${priceDropForm.periodYear}-${pad(
                      priceDropForm.periodMonth
                    )}-${pad(lastDay)}`;
                  }
                  setPriceDropForm((prev) => {
                    const updated = {
                      ...prev,
                      periodFrom,
                      periodTo,
                    };
                    return updated;
                  });
                }}
              >
                Search
              </Button>
            </Box>
          </Box>
        </div>
      </div>

      <div
        className="page-card mb-6"
      >
        <div className="block w-full overflow-x-auto py-3 px-4 lg:p-8">
          <Stack
            spacing={2}
            direction={{ md: "row", xs: "column" }}
            justifyContent={{ md: "space-between", xs: "center" }}
            className="w-full"
          >
            <div className="flex justify-center md:justify-end py-2 md:py-4 px-2 text-sky-500">
              Total: {drops.length}
            </div>
            <div className="mb-2 flex justify-center">
              <Pagination
                count={totalPages}
                page={currentPage}
                color="primary"
                onChange={handlePageChange}
                size={isMobile ? "small" : "medium"}
                className="mb-4"
              />
            </div>
          </Stack>
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <TableHeader heading="Brand Name" />
                <TableHeader heading="User Group" />
                <TableHeader heading="Primary Name" />
                <TableHeader heading="Drop Date" />
                <TableHeader heading="Price Drop Claim" />
                <TableHeader heading="Action" />
              </tr>
            </thead>
            <tbody>
              {drops?.map((s, index) => (
                <tr
                  key={s.priceDropId || index}
                  style={{ transition:"background 100ms" }} onMouseEnter={(e)=>e.currentTarget.style.background="#F8FAFC"} onMouseLeave={(e)=>e.currentTarget.style.background="transparent"}
                >
                  <TableElement value={s.brandName} />
                  <TableElement value={s.groupName} />
                  <TableElement value={s.primaryName} />
                  <TableElement value={s.dropDate} />
                  <TableElement value={s.priceDropClaimValue} />
                  <TableElement
                    value={
                      <Button
                        color="error"
                        onClick={() => handleDelete(s.priceDropId)}
                      >
                        Delete
                      </Button>
                    }
                  />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div>
        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          TransitionComponent={Transition}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Add Price Drop
              </Typography>
            </Toolbar>
          </AppBar>
          <List>
            <ListItem className="mt-4">
              <FormControl fullWidth>
                <CustomDropdown
                  options={brands}
                  value={priceDropForm.brandId || ''}
                  onChange={(selectedBrand) => {
                    setPriceDropForm({
                      ...priceDropForm,
                      brandId: selectedBrand ? selectedBrand.id : '',
                      productId: '',
                    });
                  }}
                  getOptionLabel={(option) => option.name || ''}
                  getOptionValue={(option) => option.id}
                  label="Select Brand"
                  placeholder="Type to search brands..."
                  helpText="Type to get the brands"
                  fullWidth
                  sx={{ 
                    mb: 2,
                    "& .MuiPaper-root": {
                      zIndex: 9999,
                      maxHeight: "300px"
                    },
                    "& .MuiAutocomplete-listbox": {
                      maxHeight: "250px"
                    }
                  }}
                  disableCloseOnSelect={false}
                  blurOnSelect={true}
                  forcePopupIcon={true}
                  openOnFocus={true}
                  ListboxProps={{
                    style: { maxHeight: '250px' }
                  }}
                  PopperProps={{
                    style: { zIndex: 9999, width: '100%' }
                  }}
                />
              </FormControl>
            </ListItem>
            <ListItem className="mt-4">
              <FormControl fullWidth>
                <CustomDropdown
                  options={products.filter(p => p.active)}
                  value={priceDropForm.productId || ''}
                  onChange={(selectedProduct) => {
                    setPriceDropForm({
                      ...priceDropForm,
                      productId: selectedProduct ? selectedProduct.productId : '',
                    });
                  }}
                  getOptionLabel={(option) => option.primaryName || ''}
                  getOptionValue={(option) => option.productId}
                  label="Select Product"
                  placeholder="Type to search products..."
                  helpText="Type to search products"
                  fullWidth
                  sx={{ 
                    mb: 2,
                    "& .MuiPaper-root": {
                      zIndex: 9999,
                      maxHeight: "300px"
                    },
                    "& .MuiAutocomplete-listbox": {
                      maxHeight: "250px"
                    }
                  }}
                  disableCloseOnSelect={false}
                  blurOnSelect={true}
                  forcePopupIcon={true}
                  openOnFocus={true}
                  fetchOptions={searchProducts}
                  ListboxProps={{
                    style: { maxHeight: '250px' }
                  }}
                  PopperProps={{
                    style: { zIndex: 9999, width: '100%' }
                  }}
                />
              </FormControl>
            </ListItem>
            <ListItem className="mt-4">
              <FormControl fullWidth>
                <InputLabel id="group-select-label">
                  User Group
                </InputLabel>
                <Select
                  labelId="group-select-label"
                  id="group-select"
                  value="144"
                  label="User Group"
                  disabled={true}
                  readOnly={true}
                  sx={{
                    backgroundColor: '#f5f5f5',
                    '& .MuiSelect-icon': {
                      display: 'none'
                    }
                  }}
                >
                  <MenuItem value="144">
                    <strong>P All Users</strong>
                  </MenuItem>
                </Select>
                <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5 }}>
                  Fixed to "All Users" (ID: 144)
                </Typography>
              </FormControl>
            </ListItem>
            <ListItem className="mt-4">
              <TextField
                type="date"
                onChange={(e) =>
                  setPriceDropForm({
                    ...priceDropForm,
                    dropDate: e.target.value,
                  })
                }
                value={priceDropForm.dropDate}
                fullWidth
                label="Drop Date"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            </ListItem>
            <ListItem className="mt-4">
              <TextField
                onChange={(e) =>
                  setPriceDropForm({
                    ...priceDropForm,
                    priceDropClaimValue: e.target.value,
                  })
                }
                value={priceDropForm.priceDropClaimValue}
                fullWidth
                label="Price Drop Claim Value"
                variant="outlined"
              />
            </ListItem>
          </List>
          <DialogActions sx={{ position: "fixed", bottom: 0, right: 0 }}>
            <Button onClick={save}>Save</Button>
          </DialogActions>
        </Dialog>
      </div>
      <ToastContainer />
    </>
  );
}
